/** SessionStorage key for persisting referral codes through the Clerk auth flow */
export const REFERRAL_CODE_SESSION_KEY = '42a_referral_code';

/**
 * Goal alignment score (0-100) at or above which a scored run is considered
 * "on-target". Must stay in sync with `ON_TARGET_THRESHOLD` in
 * `convex/analysis/goals.ts`, which drives the backend's on-target metrics.
 */
export const ON_TARGET_THRESHOLD = 70;

/**
 * Lower bound (0-100) of the "ok" alignment bucket. Scores at or above this but
 * below `ON_TARGET_THRESHOLD` are "ok"; below it are "bad". Mirrors
 * `ALIGNMENT_OK_THRESHOLD` in `convex/analysis/goals.ts` — keep in sync.
 */
export const ALIGNMENT_OK_THRESHOLD = 40;
